import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Subscribe from '@/views/Subscribe'
import Detail from '@/views/Detail'
import Unsubscribe from '@/views/Unsubscribe'
import Notices from '@/views/Notices'
import MapView from '@/views/MapView'
import Definitions from '@/views/Definitions'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkActiveClass: 'active',
	routes: [
		{
			path: '/',
			component: Home,
			name: 'Home',
		},
		{
			path: '/notices',
			component: Notices,
			name: 'Notices',
		},
		{
			path: '/map',
			component: MapView,
			name: 'MapView',
		},
		{
			path: '/subscribe/:parameters?',
			component: Subscribe,
			name: 'Subscribe',
		},
		{
			path: '/detail/:id',
			component: Detail,
			name: 'Detail',
		},
		{
			path: '/unsubscribe/:id/:token',
			component: Unsubscribe,
			name: 'Unsubscribe',
		},
		{
			path: '/definitions',
			component: Definitions,
			name: 'Definitions'
		}

	]
})
